/*
 * @Author: Jun
 * @Date: 2021-03-15 10:59:11
 * @LastEditTime: 2021-03-25 18:09:33
 * @LastEditors: JUN
 * @Description:
 * @FilePath: /guokr-ad/src/routes.tsx
 */
import { lazy } from "react"
import App from "./App"
import Login from "./views/Login"
import LoginGuard from "./hoc/LoginGuard"
import Home from "./views/Home"
import Calendar from "./views/Calendar"
import BeautyCalendar from "./views/BeautyCalendar"
import ChildCalendar from "./views/ChildCalendar"
import ChildrenCalendar from "./views/ChildrenCalendar"
import SpeciesCalendar from "./views/SpeciesCalendar"
import HealthCalendar from "Views/HealthCalendar"
import EatCalendar from "./views/EatCalendar"
import VideoCalendar from "./views/VideoCalendar"
import PhotoCalendar from "./views/PhotoCalendar"
import Parameter from "./views/Parameter"
import Presets from "./views/Presets"
import Weibo from "./views/Weibo"
import Wechat from "./views/Wechat"
// import Bom from "./views/Bom"
import Mpl from "./views/Mpl"
const Users = lazy(() => import("./views/Users"))
const OpLog = lazy(() => import("./views/OpLog"))
const Role = lazy(() => import("./views/Role"))
const Channel = lazy(() => import("./views/Channel"))
const AdPlace = lazy(() => import("./views/AdPlace"))
const MyBoard = lazy(() => import("./views/MyBoard"))
const Department = lazy(() => import("./views/Department"))
const Settings = lazy(() => import("./views/Settings"))
const Finance = lazy(() => import("./views/Finance"))

const routes = [
    {
        component: App,
        routes: [
            {
                path: `/login`,
                component: Login,
            },
            {
                path: "/",
                component: LoginGuard(Home),
                routes: [
                    { path: `/calendar`, component: Calendar },
                    { path: `/schedule`, component: Users },
                    { path: `/users`, component: Users },
                    { path: `/role`, component: Role },
                    { path: `/op_log`, component: OpLog },
                    { path: `/channel`, component: Channel },
                    { path: `/ad_place`, component: AdPlace },
                    { path: `/my_board`, component: MyBoard },
                    { path: `/department`, component: Department },
                    { path: `/parameter`, component: Parameter },
                    { path: `/presets`, component: Presets },
                    { path: `/weibo`, component: Weibo },
                    { path: `/wechat`, component: Wechat },
                    // { path: `/bom`, component: Bom },
                    { path: `/mpl`, component: Mpl },
                    { path: `/settings`, component: Settings },
                    { path: `/finance`, component: Finance },
                    { path: `/child_calendar`, component: ChildCalendar },
                    { path: `/beauty_calendar`, component: BeautyCalendar },
                    { path: `/children_calendar`, component: ChildrenCalendar },
                    { path: `/species_calendar`, component: SpeciesCalendar },
                    { path: '/health_calendar', component: HealthCalendar },
                    { path: `/eat_calendar`, component: EatCalendar },
                    { path: `/video_calendar`, component: VideoCalendar },
                    { path: `/photo_calendar`, component: PhotoCalendar },
                ],
            },
        ],
    },
]

export default routes
